module.exports = __webpack_public_path__ + "static/media/lMesser.fb872cd0.jpeg";